import { NamedType } from "../core.models/named-type";
import { getFieldsFromInstance } from "../core.utilidades/graphql-utils";
import { Agente } from "./agente";
import { Cliente } from "./cliente";
import { TipoSexo } from "./tipo-sexo";

export class Comunicacion implements NamedType {

    _className: string = "Comunicacion";

    id?: number;
    fechaComunicacion: Date;
    cliente: Cliente;
    agente: Agente;
    observacion: string;

    constructor() {
        this.fechaComunicacion = new Date();
        this.agente = new Agente();
        this.cliente = new Cliente();
        this.observacion = ''

    }

    public static getFields = () => {
        const instancia = new Comunicacion();
        instancia.cliente = new Cliente();
        instancia.cliente.fechaNacimiento = new Date();
        instancia.cliente.tipoSexo = new TipoSexo();
        
        return getFieldsFromInstance(instancia);
    }
}
